import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	activeSprintSelectionWarningMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	activeSprintSelectionWarningMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	activeSprintSelectionWarningMessage: {
		id: 'issue-create-commons.sprint-field.active-sprint-selection-warning-message',
		defaultMessage: "Creating this issue will affect the active sprint's scope",
		description: 'Warning message to be shown when active sprint is selected',
	},
	activeSprintSelectionWarningMessageIssueTermRefresh: {
		id: 'issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh',
		defaultMessage: "Creating this work item will affect the active sprint's scope",
		description: 'Warning message to be shown when active sprint is selected',
	},
});
export default messages;
